var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pop-in',{attrs:{"text":_vm.textGlobalOpposition,"validation-input":"Je confirme mon opposition"},on:{"close-modal":function($event){return _vm.$emit('close-modal')},"validation":function($event){_vm.$emit('validation'); _vm.$emit('close-modal')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }